export function getFileNameFromUrl(url) {
  if (!url) return '';
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const parts = pathname.split('/');
    return parts[parts.length - 1] || 'file';
  } catch {
    const parts = url.split('/');
    return parts[parts.length - 1] || 'file';
  }
}

export function getMimeTypeFromUrl(url) {
  if (!url) return 'application/octet-stream';
  const extension = url.split('.').pop().toLowerCase().split('?')[0];

  const mimeTypes = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    txt: 'text/plain',
    json: 'application/json',
    xml: 'application/xml'
  };

  return mimeTypes[extension] || 'application/octet-stream';
}
